//@flow
/*global chrome*/

import React from "react"
import type { Match } from "react-router-dom"
import styled from "styled-components"
import Loader from "../UI/Loader"
import { WaitingToRideScene, Button } from "../Kiosk"
import {
  refreshTokensForKiosk,
  refreshToken,
  accessToken,
  currentKioskID,
  saveKioskID
} from "./tokenHelpers"
import { logoutUser } from "./userHelpers"

const ErrorScreen = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
`

const ErrorText = styled.div`
  position: absolute;
  bottom: 44px;
  right: 44px;
  width: 650px;
  background: rgba(255, 255, 255, 1);
  padding: 2rem;
  z-index: 5;
`

const ErrorHeadline = styled.h1`
  font-family: "din-condensed";
  font-size: 2.5rem;
  text-transform: uppercase;
  color: #25beae;
  margin: 0 0 0.5rem 0;
  padding: 0;
`

const ErrorDescription = styled.p`
  font-family: "din-condensed";
  font-size: 1.5rem;
  color: #000;
  padding: 0;
  margin: 0 0 0 0;
`

const AccessDescription = ErrorDescription.extend`
  padding-top: 1rem;
  margin: 1rem 0;
  border-top: 1px solid #ccc;
  color: #25beae;
`

const AccessUrlInput = styled.input`
  border: 1px solid #ccc;
  padding: 0.75rem;
  display: block;
  width: 100%;
  font-size: 1.25rem;
  margin-bottom: 1rem;
`

const SubmitButton = Button.extend`
  font-size: 1rem;
  opacity: ${p => (p.inactive ? 0.5 : 1)};
`

type Props = {
  match: Match,
  history: { replace: Function, push: Function }
}

type State = {
  loading: boolean,
  validUrl: boolean,
  url: string,
  error: boolean
}

class KioskAuthenticator extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { loading: false, error: false, validUrl: false, url: "" }
  }

  isKiosk() {
    return typeof chrome === "object"
  }

  componentDidMount() {
    this.attemptRefresh()
  }

  componentDidUpdate(prevProps: Props) {
    const kioskId = this.props.match.params.kioskId
    if (kioskId && prevProps.match.params.kioskId !== kioskId) {
      this.attemptRefresh()
    }
  }

  async attemptRefresh() {
    const { match: { params: { kioskId } }, history: { replace } } = this.props
    if (kioskId) {
      const id = kioskId === "refresh" ? await currentKioskID() : kioskId
      this.setState(() => ({ loading: true }))
      await refreshTokensForKiosk(id, await refreshToken())
      this.setState(() => ({ loading: false }))
      const token = await accessToken()
      if (token) {
        saveKioskID(id)
        replace("/kiosk/attract")
      } else {
        logoutUser()
      }
    } else {
      logoutUser()
      this.setState(() => ({ loading: false, error: true }))
    }
  }

  validateUrl(url: string) {
    const test = new RegExp(`^${window.location.origin.replace("/", "/")}/go/`)
    this.setState(() => ({
      validUrl: url.match(test) ? true : false,
      url: url
    }))
  }

  launchKiosk() {
    const { url, validUrl } = this.state
    if (validUrl) {
      window.location = url
    }
  }

  renderAccessUrlForm() {
    const { validUrl } = this.state
    return [
      <AccessDescription>
        Already have an access URL? If so enter it here to launch the kiosk:
      </AccessDescription>,
      <AccessUrlInput
        type="text"
        name="accessURL"
        placeholder="Paste your access url here..."
        onChange={e => this.validateUrl(e.target.value)}
      />,
      <SubmitButton
        disabled={!validUrl}
        inactive={!validUrl}
        onClick={() => this.launchKiosk()}
      >
        Launch Kiosk
      </SubmitButton>
    ]
  }

  render() {
    const { loading, error } = this.state
    return (
      <Loader loading={loading}>
        {error || !loading ? (
          <ErrorScreen>
            <WaitingToRideScene />
            <ErrorText>
              <ErrorHeadline>
                Waiting to ride the clean air kiosk?
              </ErrorHeadline>
              <ErrorDescription>
                It looks like the sign in link you used has expired. Please
                contact your local adminstrator to gain access.
              </ErrorDescription>
              {this.isKiosk() ? <span /> : this.renderAccessUrlForm()}
            </ErrorText>
          </ErrorScreen>
        ) : null}
      </Loader>
    )
  }
}

export default KioskAuthenticator



// WEBPACK FOOTER //
// ./src/Auth/KioskAuthenticator.js